import { ref } from 'vue'
import { useSnackbarStore } from '@/ai_studio/stores/snackbar';

let isVisible = ref(false);
let articles = ref([]);
let title = ref('');
let loading = ref(false);

export const helpbar = {
  isVisible,
  articles,
  title,
  loading,
  
  async open(pageTitle) {
    try {
      const snackbar = useSnackbarStore();
      if (title.value !== pageTitle || articles.value.length === 0 && !loading.value) {
        loading.value = true;
        title.value = pageTitle
        const response = await fetch(`/api/getpagesarticles?key=${pageTitle.toLowerCase()}`)
        const data = await response.json();
        if (!data.success) {
          snackbar.error("Não foi possível carregar os artigos");
          return console.error('Erro ao abrir a barra lateral:', data.message)
        }
          articles.value = data.data
      }
      isVisible.value = true;
      loading.value = false;
    } catch (error) {
      console.error('Erro ao abrir a barra lateral:', error)
    }
  },

  close() {
    isVisible.value = false
  },

  clearArticles() {
    articles.value = []
    title.value = ''
  }
}